import ReactDOM from 'react-dom';
import {useCallback, useEffect, useState} from "react";
import LabeledSelect from "../../components/selects/LabeledSelect";
import {FOCUS_ITEM_SUB_TYPES} from "../dynamicUi/constants";
import {ComponentError} from "../../components/ComponentLoader";
import {getCmsFocusedItems, getFocusedItem} from "../../redux/sagas/requests/focusedItemsService";
import {FocusItemDataPreviewView} from "../focusItems/components/FocusItemsPreviewModal";
import {debounce} from "lodash";
import {alreadyDeletedMessage} from "../../redux/sagas/handlers/dynamicMultipleElements";

export class FocusedItemBlockTool {

  static get toolbox() {
    return {
      title: 'Focus Item',
      icon: '<svg width="17" height="15" viewBox="0 0 336 276" xmlns="http://www.w3.org/2000/svg"><path d="M291 150V79c0-19-15-34-34-34H79c-19 0-34 15-34 34v42l67-44 81 72 56-29 42 30zm0 52l-43-30-56 30-81-67-66 39v23c0 19 15 34 34 34h178c17 0 31-13 34-29zM79 0h178c44 0 79 35 79 79v118c0 44-35 79-79 79H79c-44 0-79-35-79-79V79C0 35 35 0 79 0z"/></svg>'
    };
  }

  #container;
  #editorJSChangeEventID;
  #text;

  constructor({data}) {
    this.#container = document.createElement("div");
    this.#editorJSChangeEventID = new Date().getTime();
    this.#text = "";
    this.section = {
      value: data?.value ?? "",
      type: data?.type ?? "",
      extras: data?.extras ?? {},
      stretched: data.stretched !== undefined ? data?.stretched : true
    };

    if (!this.section.stretched) {
      this.#container.classList.add('blog-width');
    }
  }


  renderSettings() {
    const settings = [

      {
        name: 'Stretch',
        alternate: 'UnStretch',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9L20 12L17 15"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 12H20"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 9L4 12L7 15"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 12H10"></path></svg>`
      }

    ];
    const wrapper = document.createElement('div');
    wrapper.classList.add('blogs-focused-settings-container');

    settings.forEach(tune => {

      let wrapperDiv = document.createElement('div');
      wrapperDiv.classList.add('ce-popover-item');
      if (this.section.stretched) {
        wrapperDiv.classList.add('ce-popover-item--active');
      }


      let imageDiv = document.createElement('div');
      imageDiv.classList.add('ce-popover-item__icon');
      imageDiv.innerHTML = tune.icon;
      wrapperDiv.appendChild(imageDiv);

      let textDiv = document.createElement('div');
      textDiv.classList.add('ce-popover-item__title');
      textDiv.innerHTML = tune.name;

      wrapperDiv.appendChild(textDiv);

      //in case you want 2 texts as per the condition
      // let textMainDiv = document.createElement('div');
      // textMainDiv.classList.add('ce-popover-item__title');
      //
      // let textSpan1 = document.createElement('span');
      // textSpan1.innerHTML = tune.name;
      // textSpan1.classList.add('main-text');
      //
      // let textSpan2 = document.createElement('span');
      // textSpan2.innerHTML = tune.alternate;
      // textSpan2.classList.add('alt-text');
      //
      // textMainDiv.appendChild(textSpan1);
      // textMainDiv.appendChild(textSpan2);
      //
      // wrapperDiv.appendChild(textMainDiv);

      wrapperDiv.addEventListener('click', () => {
        this._toggleStretch();
        wrapperDiv.classList.toggle('ce-popover-item--active');

      });


      wrapper.appendChild(wrapperDiv);
    });

    return wrapper;
  }

  _toggleStretch() {
    this.section.stretched = !this.section.stretched;
    this.#container.classList.toggle('blog-width');
  }


  render() {
    this.renderContainer();

    return this.#container;
  }

  save() {
    return {
      ...this.section
    };
  }

  #dispatchData = (action) => {
    if (action.value !== undefined) {
      this.section = {...this.section, ...action};
    }

    // Dispatch Editor.js change event even without DOM changes.
    // this.#editorJSChangeEventID = new Date().getTime();
    //
    // this.renderContainer();
  };

  renderContainer() {
    ReactDOM.render(
      <div data-editorjs-change-event-id={this.#editorJSChangeEventID}>
        <_Content dispatchData={this.#dispatchData} id={this.section.value} stretched={this.section.stretched}/>
      </div>,
      this.#container
    );
  }
}

const _Content = ({dispatchData, id, stretched}) => {

  const [iD, setId] = useState(id);
  const [focusType, setFocusType] = useState({value: "", label: "All"});

  return (
    <>
      {iD ? <_FocusedInfo id={iD}/> :
        <div className="relative p-4 pt-4 mb-4 border bg-secondary-100 rounded-md">
          <div className="font-bold mb-2">Add Focus Item</div>

          <div className="flex space-x-4 items-center">
            <div className="w-56 shrink-0">
              <LabeledSelect options={[{value: "", label: "All"}, ...FOCUS_ITEM_SUB_TYPES]} value={focusType}
                             onChange={setFocusType}
                             emptyMsg={'Select type first'}
                             label="Focus Item Type"
              />
            </div>
            <div className="flex-1">
              <FocusedSearchSelect label="Search for focus item..." type={focusType.value} onChange={(f) => {
                dispatchData({value: f.id, extras: f.extras, type: f.type});
                setId(f.id);
              }}/>
            </div>
          </div>

        </div>
      }


    </>

  );
};

const _FocusedInfo = ({id}) => {

  const [focusInfo, setFocusInfo] = useState({loading: false, error: "", data: {}});

  useEffect(() => {
    loadFocusedInfo();
  }, []);


  const loadFocusedInfo = () => {
    setFocusInfo({...focusInfo, loading: true, error: ""});
    getFocusedItem(id).then((resp) => {
      setFocusInfo({...focusInfo, loading: false, data: resp.data});
    }).catch((error) => {
      const errMsg = !error.response ? error.message : error.response.status === 404 ? alreadyDeletedMessage : error.response.data.message;
      setFocusInfo({...focusInfo, loading: false, error: errMsg});
    });
  };


  return (
    <>
      {
        focusInfo.error ? <ComponentError className="aspect-[3]" errorMsg={focusInfo.error}
                                          retry={loadFocusedInfo}/> : focusInfo.loading ?
          <div className="flex justify-center aspect-[3] bg-gray-200 animate-pulse mb-4"/> :
          <div
            className="mb-4">
            <FocusItemDataPreviewView data={focusInfo.data} mobile={false} fromBlog={true}/>
          </div>
      }
    </>
  );
};

const FocusedSearchSelect = ({
                               label, value, onChange, placeholder = "Start typing to search..", type,
                               emptyMsg = "No data", ...props
                             }) => {


  // noinspection JSCheckFunctionSignatures
  const debouncedSearchBrand = useCallback(
    debounce((inputText, callback) => {

      getCmsFocusedItems({searchText: inputText, ...(!!type && {type})}).then((options) =>
        callback(options.data)
      ).catch((e)=>console.log(e));

    }, 500),
    [type]
  );


  return (
    <LabeledSelect label={label} value={value} getOptionLabel={(option) => option.title}
                   getOptionValue={(option) => option.id} placeholder={placeholder}
                   onChange={onChange} emptyMsg={emptyMsg} {...props} loadOptions={debouncedSearchBrand}/>
  );


};